import React from "react";
import { Link } from "react-router-dom";
import TechConsultant from "../assets/images/tech-consulting.jpg";
import BrandSupport from "../assets/images/brand-support.jpg";
import DigitalContent from "../assets/images/digital-content.jpg";
import ChamberOfCommerce from "../assets/images/chamber-of-commerce.jpg";
import { GiShakingHands } from "react-icons/gi";
import { MdContactSupport } from "react-icons/md";
import { TfiLayoutCtaBtnLeft } from "react-icons/tfi";
import QR from "../assets/images/qr.jpg";
import SwiperComponent from "../components/Swiper";

import "../assets/css/home.css";

import transition from "../transition";

function Home() {
    return (
        <main>
            <center>
                <h1 className="blue mt-3">
                    BIG ANSWERS FOR SMALL BUSINESS
                </h1>
                <p className="paragraph">
                    There are a variety of tools for online representation and marketing available to businesses that increase sales and customer engagement. They work best when they work together as part of a plan.
                    <br />
                    We help our clients with the big picture and take care of the details.
                </p>

                <section className="what-we-do">

                    <div className="card">
                        <div className="img-container">
                            <img src={TechConsultant} alt="Tech Consultant" />
                            <h2>Technology Consulting</h2>
                            <Link to="/technology" className="icon">
                                <GiShakingHands />
                            </Link>
                        </div>
                        <p>
                            Business Strategy <br />
                            Website Development <br />
                            Point of Sale Systems <br />
                            QR code Inventory <br />
                            Database Development <br />

                        </p>
                    </div>

                    <div className="card">
                        <div className="img-container">
                            <img src={BrandSupport} alt="Brand Support" />
                            <h2>Brand Support</h2>
                            <Link to="/brand" className="icon">
                                <MdContactSupport />
                            </Link>
                        </div>
                        <p>
                            Brand Strategy <br />
                            Online Marketing <br />
                            Target Marketing <br />
                            Assets & Messaging <br />
                            Content Strategy <br />
                        </p>
                    </div>

                    <div className="card">
                        <div className="img-container">
                            <img src={DigitalContent} alt="Digital Content" />
                            <h2>Digital Content</h2>
                            <Link to="/digital" className="icon">
                                <TfiLayoutCtaBtnLeft />
                            </Link>
                        </div>
                        <p>
                            Social Medial Management <br />
                            Content Creation <br />
                            Text - Audio - Video <br />
                            SEO Management <br />
                            Marketing Materials <br />
                        </p>
                    </div>

                </section>

                <section>
                    <p className="how-to-use paragraph mt-3 blue">
                        How you use technology in your business affects work efficiency and job satisfaction.
                        <br />
                        You need to know all options in order to make a good decision.
                        <br />
                        Discuss and plan with experienced technical specialists.
                    </p>
                    <h2 className="blue">DESIGN - DEVELOPMENT - DELIVERY - ANALYSIS</h2>
                </section>

                <section className="grant-section">
                    <div className="grant-container">
                        <h1 className="blue">GRANT OF $2400 TO BUILD OR UPGRADE</h1>
                        <p className="paragraph">We assist companies to apply for the <span className="blue">"GROW YOUR BUSINESS ONLINE GRANT"</span>
                            from the Ontario Chamber of Commerce that gives them $2400 toward a new/upgraded website, digital checkout, customer management, search engine optimization and customer database.</p>
                        <div className="home-image-container">
                            <div>
                                <img src={ChamberOfCommerce} alt="Chamber Of Commerce Logo" className="chamber-of-commerce-logo" />
                            </div>
                            <div>
                                <h4 className="blue">FOR MORE INFORMATION ABOUT THIS GRANT</h4>
                                <h6><a className="blue" href="https://occ.ca/growyourbusinessonline">https://occ.ca/growyourbusinessonline</a></h6>
                            </div>
                            <div>
                                <img src={QR} alt="QR Code" className="qr-code" />
                            </div>
                        </div>
                    </div>
                </section>
            </center>
            <div className="p-4 pt-0">
                <h1 className="text-center mb-1 blue">
                    Sampling Of Our Clients
                </h1>
                <SwiperComponent />
            </div>
        </main>
    );
}

export default transition(Home);
